import { createEffect, createSignal } from "solid-js";
import * as styles from "./css/HealthBar.module.css";
import { playerState } from "@stores";
import { PlayerConfig } from "@objects/entities";
const HealthBar = () => {
    const [width, setWidth] = createSignal(0);
    const [color, setColor] = createSignal("var(--accent-red)");
    /**
     * Update the width and color of the health bar.
     */
    const updateValues = () => {
        const _health = playerState()?.health;
        if (_health === undefined)
            return;
        const percentage = getPercentage(_health, PlayerConfig.MAX_HEALTH);
        updateWidth(percentage);
        updateColor(percentage);
    };
    /**
     * Update the width of the health bar based on the remaining health percentage.
     * @param percentage the percentage of remaining health.
     */
    const updateWidth = (percentage) => {
        setWidth(percentage);
    };
    /**
     * Update the color of health bar based on the remaining health percentage.
     * @param percentage the percentage of remaining health.
     */
    const updateColor = (percentage) => {
        if (percentage >= 70)
            return setColor("var(--accent-green)");
        if (percentage <= 30)
            return setColor("var(--accent-red)");
        return setColor("var(--accent-yellow)");
    };
    /**
     * Calculate the percentage of remaining health.
     * @param value current health.
     * @param maxValue maximum health.
     * @returns the calculated percentage.
     */
    const getPercentage = (value, maxValue) => {
        if (value === 0)
            return 0;
        return Math.round((value / maxValue) * 100);
    };
    createEffect(updateValues);
    return (<div class={styles.container}>
            <span class={styles.healthbar} style={{ width: `${width()}%`, "background-color": color() }}/>
        </div>);
};
export default HealthBar;
